module.exports = __webpack_public_path__ + "static/media/abbottabad-dark.7fe52f53.svg";